const API_BASE = import.meta.env.VITE_API_BASE_URL || 'https://admin.reelora.vip'

export type AnyRecord = Record<string, any>

const CATALOG_PAGE_SIZE = 48

function storedToken(): string {
  try {
    const raw = localStorage.getItem('user')
    const parsed = raw ? JSON.parse(raw) : null
    return String(parsed?.token || parsed?.userInfo?.token || '')
  } catch { return '' }
}

export async function api<T = AnyRecord>(path: string, params: Record<string, string | number> = {}): Promise<T> {
  const url = new URL(path, API_BASE)
  Object.entries(params).forEach(([key, value]) => url.searchParams.set(key, String(value)))
  const token = storedToken()
  const response = await fetch(url, {
    headers: {
      'Accept-Language': 'en',
      'X-App-Code': 'reelora',
      server: '1',
      ...(token ? { token } : {}),
    },
  })
  if (!response.ok) throw new Error(`Request failed (${response.status})`)
  const payload = await response.json()
  if (payload?.code !== 1) throw new Error(payload?.msg || 'Reelora could not load this page')
  return payload.data as T
}

export const pcApi = {
  home: () => api('/api/drama.home/index'),
  /** Broad catalog browse — keyword "." matches the full playable library. */
  browse: (page = 1, limit = CATALOG_PAGE_SIZE) =>
    api('/api/drama.search/drama', { keyword: '.', page, pageSize: limit, limit }),
  search: (keyword: string, page = 1, limit = CATALOG_PAGE_SIZE) =>
    api('/api/drama.search/drama', { keyword, page, pageSize: limit, limit }),
  categories: () => api('/api/drama.categories/index'),
  category: (id: string, page = 1, limit = CATALOG_PAGE_SIZE) =>
    api('/api/drama.categories/detail', { id, page, limit }),
  ranking: (period: string, page = 1, limit = CATALOG_PAGE_SIZE) =>
    api('/api/drama.rankings/index', { period_type: period, page, limit }),
  detail: (id: string) => api('/api/drama.dramas/episodes', { id }),
  play: (episodeId: number) => api('/api/drama.dramas/play', { episode_id: episodeId }),
  history: () => api('/api/drama.history/index', { page: 1, pageSize: 24 }),
  rewards: () => Promise.all([api('/api/sign/status'), api('/api/task/list', { grouped: 1 })]),
  profile: () => api('/api/user/info'),
  vipPlans: () => api('/api/user/packages', { type: 'vip', payment_channel: 'stripe' }),
}

export { CATALOG_PAGE_SIZE }
